import { jsxs, jsx } from "react/jsx-runtime";
import { useId } from "react";
const skeleton = "_skeleton_167pl_1";
const backgroundStop = "_backgroundStop_167pl_11";
const shimmerStop = "_shimmerStop_167pl_15";
const styles = {
  skeleton,
  backgroundStop,
  shimmerStop
};
const Skeleton = ({ children, ariaLabel, height, width, ...props }) => {
  const uniqueId = useId();
  const clipPathId = `clip-path-${uniqueId}`;
  const gradientId = `gradient-${uniqueId}`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-label": ariaLabel,
      "aria-busy": true,
      className: styles.skeleton,
      height,
      width,
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            clipPath: `url(#${clipPathId})`,
            x: "0",
            y: "0",
            width: "100%",
            height,
            style: { "--gradient-id": `url(#${gradientId})` }
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, children: [
          /* @__PURE__ */ jsx("stop", { offset: "10%", className: styles.backgroundStop, children: /* @__PURE__ */ jsx(
            "animate",
            {
              attributeName: "offset",
              values: "-1.5; 1",
              dur: "1.5s",
              repeatCount: "indefinite"
            }
          ) }),
          /* @__PURE__ */ jsx("stop", { offset: "50%", className: styles.shimmerStop, children: /* @__PURE__ */ jsx(
            "animate",
            {
              attributeName: "offset",
              values: "-1.5; 1.5",
              dur: "1.5s",
              repeatCount: "indefinite"
            }
          ) }),
          /* @__PURE__ */ jsx("stop", { offset: "90%", className: styles.backgroundStop, children: /* @__PURE__ */ jsx(
            "animate",
            {
              attributeName: "offset",
              values: "-1.5; 2",
              dur: "1.5s",
              repeatCount: "indefinite"
            }
          ) })
        ] }) }),
        /* @__PURE__ */ jsx("clipPath", { id: clipPathId, children })
      ]
    }
  );
};
export {
  Skeleton
};
